import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { getNoticeStyles, noticeIconStyles } from './CicEditReasonNotice.styles';

const CicEditReasonNotice = ({ message, isError = false, dataTestId = null }) => (
  <Box data-testid={dataTestId} sx={getNoticeStyles({ isError })}>
    <InfoIcon size={IconSize[16]} style={noticeIconStyles} />
    <Typography color={isError ? 'text.primary' : 'text.secondary'} variant="regular14">
      {message}
    </Typography>
  </Box>
);

CicEditReasonNotice.propTypes = {
  message: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  isError: PropTypes.bool,
};

export default memo(CicEditReasonNotice);
